/**
 * Variantes visuais do Button.
 *
 * Em arquivo proprio porque `Button.tsx` so pode exportar componentes — export misto
 * derruba o Fast Refresh do modulo inteiro (react-refresh/only-export-components).
 */
import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  // Base styles
  `inline-flex items-center justify-center gap-2 rounded-lg font-medium
   transition-all duration-200 ease-out
   focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
   disabled:pointer-events-none disabled:opacity-50
   active:scale-[0.98]`,
  {
    variants: {
      variant: {
        primary: `bg-primary-600 text-white hover:bg-primary-700
                  focus-visible:ring-primary-500
                  shadow-sm hover:shadow-primary`,
        secondary: `bg-secondary-500 text-white hover:bg-secondary-600
                    focus-visible:ring-secondary-500
                    shadow-sm hover:shadow-secondary`,
        outline: `border-2 border-primary-500 text-primary-600
                  hover:bg-primary-50 focus-visible:ring-primary-500
                  bg-transparent`,
        ghost: `text-primary-600 hover:bg-primary-50
                focus-visible:ring-primary-500
                bg-transparent`,
        danger: `bg-red-500 text-white hover:bg-red-600
                 focus-visible:ring-red-500
                 shadow-sm`,
        link: `text-primary-600 underline-offset-4 hover:underline
               bg-transparent p-0 h-auto`,
      },
      size: {
        sm: 'h-9 px-3 text-sm',
        md: 'h-10 px-4 text-sm',
        lg: 'h-12 px-6 text-base',
        xl: 'h-14 px-8 text-lg',
        icon: 'h-10 w-10 p-0',
      },
      fullWidth: {
        true: 'w-full',
        false: '',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
      fullWidth: false,
    },
  }
)
